export default {
  'trendelenburg': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'trendelenburg',
    opposite: 'reverse_trendelenburg',
    conflicting: [
      'trendelenburg_z_minima',
      'reverse_trendelenburg',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting3',
      'combined_tilting4',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'mobilization_position',
      'mobilization_from_min',
    ],
    conditional: [
      {
        conditionalAnimation: 'bed_height_adjustment_down',
        substituteAnimation: 'trendelenburg_z_minima'
      },
      {
        conditionalAnimation: 'bed_height_adjustment_up',
        substituteAnimation: 'trendelenburg_z_minima_do_maxima_backward'
      }
    ]
  },
  'reverse_trendelenburg': {
    cs: 'Reverzní Trendelenburg',
    en: 'Reverse Trendelenburg',
    track: 'reverseTrendelenburg',
    opposite: 'trendelenburg',
    conflicting: [
      'trendelenburg',
      'trendelenburg_z_minima',
      'emergency_trendelenburg',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting3',
      'combined_tilting4',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'mobilization_position',
      'mobilization_from_min',
    ],
    conditional: [
      {
        conditionalAnimation: 'bed_height_adjustment_up',
        substituteAnimation: 'rev_trendelengurg_z_maxima'
      },
      {
        conditionalAnimation: 'bed_height_adjustment_down',
        substituteAnimation: 'rev_trendelenburg_do_min_backward'
      },
    ]
  },
  'emergency_trendelenburg': {
    cs: 'Emergency Trendelenburg',
    en: 'Emergency Trendelenburg',
    track: 'trendelenburg',
    conflicting: [
      'reverse_trendelenburg',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'vascular_position',
      'mobilization_position',
      'mobilization_from_min',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
      'bed_height_adjustment_up',
      'trendelenburg_z_minima',
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting3',
      'combined_tilting4',
    ],
    reverseInOrder: [
      'backrest_adjustment',
      'leg_adjustment'
    ],
    conditional: [
      {
        conditionalAnimation: 'bed_height_adjustment_down',
        substituteAnimation: 'trendelenburg_z_minima'
      }
    ],
    reversable: false
  },
  'bed_height_adjustment_up': {
    cs: 'Zvedání ložné plochy',
    en: 'Bed Height Adjustment',
    track: 'BED_HEIGHT_ADJUSTMENT_MAX',
    opposite: 'bed_height_adjustment_down',
    conflicting: [
      'trendelenburg',
      'reverse_trendelenburg',
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting3',
      'combined_tilting4',
      'mobilization_position',
      'mobilization_from_min',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
    ],
    conditional: [
      {
        conditionalAnimation: 'trendelenburg',
        substituteAnimation: 'trendelenburg_z_minima_do_maxima'
      },
      {
        conditionalAnimation: 'reverse_trendelenburg',
        substituteAnimation: 'rev_trendelengurg_z_maxima_backward'
      }
    ]
  },
  'bed_height_adjustment_down': {
    cs: 'Zvedání ložné plochy',
    en: 'Bed Height Adjustment',
    track: 'BED_HEIGHT_ADJUSTMENT_MIN',
    opposite: 'bed_height_adjustment_up',
    conflicting: [
      'vascular_position',
      'trendelenburg_z_minima',
      'trendelenburg',
      'reverse_trendelenburg',
      'emergency_trendelenburg',
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting3',
      'combined_tilting4',
      'mobilization_position',
      'mobilization_from_min',
      'cardiac_chair',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
    ],
    conditional: [
      {
        conditionalAnimation: 'mobilization_position',
        substituteAnimation: 'mobilization_to_min'
      },
      {
        conditionalAnimation: 'reverse_trendelenburg',
        substituteAnimation: 'rev_trendelenburg_do_min'
      },
      {
        conditionalAnimation: 'trendelenburg',
        substituteAnimation: 'trendelenburg_z_minima_reversed'
      }
    ]
  },
  'combined_tilting1': {
    cs: 'Kombinovaný náklon',
    en: 'Combined tilting',
    track: 'trenLatPlus10',
    conflicting: [
      'bed_height_adjustment_up',
      'bed_height_adjustment_down',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'vascular_position',
      'mobilization_position',
      'mobilization_from_min',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
      'trendelenburg',
      'reverse_trendelenburg',
      'trendelenburg_z_minima',
      'emergency_trendelenburg',
      'combined_tilting2',
      'combined_tilting3',
      'combined_tilting4',
    ]
  },
  'combined_tilting2': {
    cs: 'Kombinovaný náklon',
    en: 'Combined tilting',
    track: 'revTrenLatPlus10',
    conflicting: [
      'bed_height_adjustment_up',
      'bed_height_adjustment_down',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'vascular_position',
      'mobilization_position',
      'mobilization_from_min',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
      'trendelenburg',
      'reverse_trendelenburg',
      'trendelenburg_z_minima',
      'emergency_trendelenburg',
      'combined_tilting1',
      'combined_tilting3',
      'combined_tilting4',
    ]
  },
  'combined_tilting3': {
    cs: 'Kombinovaný náklon',
    en: 'Combined tilting',
    track: 'revTrenLatMinus10',
    conflicting: [
      'bed_height_adjustment_up',
      'bed_height_adjustment_down',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'vascular_position',
      'mobilization_position',
      'mobilization_from_min',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
      'trendelenburg',
      'reverse_trendelenburg',
      'trendelenburg_z_minima',
      'emergency_trendelenburg',
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting4',
    ]
  },
  'combined_tilting4': {
    cs: 'Kombinovaný náklon',
    en: 'Combined tilting',
    track: 'trenLatMinus10',
    conflicting: [
      'bed_height_adjustment_up',
      'bed_height_adjustment_down',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'vascular_position',
      'mobilization_position',
      'mobilization_from_min',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
      'trendelenburg',
      'reverse_trendelenburg',
      'trendelenburg_z_minima',
      'emergency_trendelenburg',
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting3',
    ]
  },
  'frame_based_lateral_tilt_left15': {
    cs: 'Laterální náklon ložné plochy (vlevo)',
    en: 'Frame-based Lateral Tilt (Left)',
    track: 'FRAME_BASED_LATERAL_TILT_LEFT15',
    opposite: 'frame_based_lateral_tilt_right',
    conflicting: [
      'trendelenburg',
      'reverse_trendelenburg',
      'trendelenburg_z_minima',
      'emergency_trendelenburg',
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting3',
      'combined_tilting4',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'mobilization_position',
      'mobilization_from_min',
    ]
  },
  'frame_based_lateral_tilt_right15': {
    cs: 'Laterální náklon ložné plochy (vpravo)',
    en: 'Frame-based Lateral Tilt (Right)',
    track: 'FRAME_BASED_LATERAL_TILT_RIGHT15',
    opposite: 'frame_based_lateral_tilt_left',
    conflicting: [
      'trendelenburg',
      'reverse_trendelenburg',
      'trendelenburg_z_minima',
      'emergency_trendelenburg',
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting3',
      'combined_tilting4',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'mobilization_position',
      'mobilization_from_min',
    ]
  },
  'frame_based_lateral_tilt_left30': {
    cs: 'Laterální náklon ložné plochy (vlevo)',
    en: 'Frame-based Lateral Tilt (Left)',
    track: 'FRAME_BASED_LATERAL_TILT_LEFT30',
    opposite: 'frame_based_lateral_tilt_right',
    conflicting: [
      'trendelenburg',
      'reverse_trendelenburg',
      'trendelenburg_z_minima',
      'emergency_trendelenburg',
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting3',
      'combined_tilting4',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'mobilization_position',
      'mobilization_from_min',
    ]
  },
  'frame_based_lateral_tilt_right30': {
    cs: 'Laterální náklon ložné plochy (vpravo)',
    en: 'Frame-based Lateral Tilt (Right)',
    track: 'FRAME_BASED_LATERAL_TILT_RIGHT30',
    opposite: 'frame_based_lateral_tilt_left',
    conflicting: [
      'trendelenburg',
      'reverse_trendelenburg',
      'trendelenburg_z_minima',
      'emergency_trendelenburg',
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting3',
      'combined_tilting4',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'mobilization_position',
      'mobilization_from_min',
    ]
  },
  'calfrest_adjustment': {
    cs: 'Zvedání lýtek',
    en: 'Calfrest Adjustment',
    track: 'CALFREST_ADJUSTMENT01',
    conflicting: ['vascular_position']
  },
  'calfrest_adjustment2': {
    cs: 'Zvedání lýtek',
    en: 'Calfrest Adjustment',
    track: 'CALFREST_ADJUSTMENT02',
    conflicting: ['vascular_position']
  },
  'calfrest_adjustment_rev': {
    cs: 'Zvedání lýtek',
    en: 'Calfrest Adjustment',
    track: 'CALFREST_ADJUSTMENT01REV',
    conflicting: ['vascular_position']
  },
  'calfrest_adjustment2_rev': {
    cs: 'Zvedání lýtek',
    en: 'Calfrest Adjustment',
    track: 'CALFREST_ADJUSTMENT02REV',
    conflicting: ['vascular_position']
  },
  'thighrest_adjustment': {
    cs: 'Zvedání stehen',
    en: 'Thighrest Adjustment',
    track: 'THIGHREST_ADJUSTMENT',
    conflicting: ['vascular_position']
  },
  'thighrest_adjustment_rev': {
    cs: 'Zvedání stehen',
    en: 'Thighrest Adjustment',
    track: 'THIGHREST_ADJUSTMENT_REV',
    conflicting: ['vascular_position']
  },
  'vascular_position': {
    cs: 'Zvednutí lýtek nahoru',
    en: 'Vascular Position',
    track: 'VASCULAR_POSITION',
    conflicting: [
      'cardiac_chair',
      'cardiac_chair_from_min',
      'mobilization_position',
      'mobilization_from_min',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
    ],
    reverseInOrder: [
      'leg_adjustment'
    ],
    reversable: false
  },
  'electrical_bed_extension': {
    cs: 'Prodloužení nohou',
    en: 'Electrical Bed Extension',
    track: 'ELECTRICAL_BED_EXTENSION',
    conflicting: []
  },
  'backrest_adjustment': {
    cs: 'Zvednutí zádového dílu',
    en: 'Backrest Adjustment',
    track: 'BACKREST_ADJUSTMENT',
    conflicting: ['cardiac_chair']
  },
  'backrest_adjustment30': {
    cs: 'Zvednutí zádového dílu',
    en: 'Backrest Adjustment',
    track: 'BACKREST_ADJUSTMENT30',
    conflicting: ['cardiac_chair']
  },
  'backrest_adjustment45': {
    cs: 'Zvednutí zádového dílu',
    en: 'Backrest Adjustment',
    track: 'BACKREST_ADJUSTMENT45',
    conflicting: ['cardiac_chair']
  },
  'backrest_adjustment70': {
    cs: 'Zvednutí zádového dílu',
    en: 'Backrest Adjustment',
    track: 'BACKREST_ADJUSTMENT70',
    conflicting: ['cardiac_chair']
  },
  'backrest_adjustment30rev': {
    cs: 'Sklopeni zádového dílu',
    en: 'Backrest Adjustment',
    track: 'BACKREST_ADJUSTMENT30REV',
    conflicting: ['cardiac_chair']
  },
  'backrest_adjustment45rev': {
    cs: 'Sklopeni zádového dílu',
    en: 'Backrest Adjustment',
    track: 'BACKREST_ADJUSTMENT45REV',
    conflicting: ['cardiac_chair']
  },
  'backrest_adjustment70rev': {
    cs: 'Sklopeni zádového dílu',
    en: 'Backrest Adjustment',
    track: 'BACKREST_ADJUSTMENT70REV',
    conflicting: ['cardiac_chair']
  },
  'folding_of_foot_siderails': {
    cs: 'Středová postranice dolů',
    en: 'Folding of Foot Siderails',
    track: 'FOLDING_OF_FOOT_SIDERAILS',
    conflicting: ['mobilization_position']
  },
  'folding_of_head_siderails': {
    cs: 'Hlavová postranice dolů',
    en: 'Folding of Head Siderails',
    track: 'FOLDING_OF_HEAD_SIDERAILS',
    conflicting: ['mobilization_position']
  },
  'trendelenburg_z_minima_do_maxima': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'TRENDELENBURG_Z_MINIMA_DO_MAXIMA',
    conflicting: [],
    overrides: [
      {
        animation: 'trendelenburg',
        reverse: true
      },
      {
        animation: 'bed_height_adjustment_up',
        reverse: false
      },
    ]
  },
  'trendelenburg_z_minima_do_maxima_backward': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'TRENDELENBURG_Z_MINIMA_DO_MAXIMA_BACKWARD',
    conflicting: [],
    overrides: [
      {
        animation: 'trendelenburg',
        reverse: false
      },
      {
        animation: 'bed_height_adjustment_up',
        reverse: true
      },
    ]
  },
  'trendelenburg_z_minima': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'TRENDELENBURG_Z_MINIMA',
    conflicting: [],
    overrides: [
      {
        animation: 'trendelenburg',
        reverse: false
      },
      {
        animation: 'bed_height_adjustment_down',
        reverse: true
      },
    ]
  },
  'trendelenburg_z_minima_reversed': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'TRENDELENBURG_Z_MINIMA_REVERSED',
    conflicting: [],
    overrides: [
      {
        animation: 'trendelenburg',
        reverse: true
      },
      {
        animation: 'bed_height_adjustment_down',
        reverse: false
      },
    ],
    reverseInOrder: [
      'backrest_adjustment',
      'leg_adjustment'
    ],
  },
  'rev_trendelenburg_do_min': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'REV_TRENDELENBURG_DO_MIN',
    conflicting: [],
    overrides: [
      {
        animation: 'reverse_trendelenburg',
        reverse: true
      },
      {
        animation: 'bed_height_adjustment_down',
        reverse: false
      },
    ],
    reverseInOrder: [
      'backrest_adjustment',
      'leg_adjustment'
    ],
  },
  'rev_trendelenburg_do_min_backward': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'REV_TRENDELENBURG_DO_MIN_BACKWARD',
    conflicting: [],
    overrides: [
      {
        animation: 'reverse_trendelenburg',
        reverse: false
      },
      {
        animation: 'bed_height_adjustment_down',
        reverse: true
      },
      {
        animation: 'mobilization_from_min',
        reverse: true
      },
    ]
  }, 
  'rev_trendelengurg_z_maxima': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'REV_TRENDELENGURG_Z_MAXIMA',
    conflicting: [],
    overrides: [
      {
        animation: 'reverse_trendelenburg',
        reverse: false
      },
      {
        animation: 'bed_height_adjustment_up',
        reverse: true
      },
    ]
  },
  'rev_trendelengurg_z_maxima_backward': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'REV_TRENDELENGURG_Z_MAXIMA_BACKWARD',
    conflicting: [],
    overrides: [
      {
        animation: 'reverse_trendelenburg',
        reverse: true
      },
      {
        animation: 'bed_height_adjustment_up',
        reverse: false
      },
    ]
  },
  'cardiac_chair': {
    cs: 'Kardiacké křeslo',
    en: 'Cardiac Chair',
    track: 'cardiac_chair',
    conflicting: [
      'bed_height_adjustment_up',
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting3',
      'combined_tilting4',
      'vascular_position',
      'mobilization_position',
      'mobilization_from_min',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
      'trendelenburg',
      'reverse_trendelenburg',
    ],
    reverseInOrder: [
      'backrest_adjustment',
      'leg_adjustment'
    ],
    conditional: [
      {
        conditionalAnimation: 'bed_height_adjustment_down',
        substituteAnimation: 'cardiac_chair_from_min'
      }
    ],
    reversable: false
  },
  'cardiac_chair_from_min': {
    cs: 'Kardiacké křeslo',
    en: 'Cardiac Chair',
    track: 'cardiac_chair_FROM_MIN',
    conflicting: [
      'vascular_position',
      'mobilization_position',
      'mobilization_from_min',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
      'trendelenburg',
      'reverse_trendelenburg',
    ],
    overrides: [
      {
        animation: 'cardiac_chair',
        reverse: false
      }
    ],
    reverseInOrder: [
      'leg_adjustment'
    ],
    reversable: false
  },
  'cardiac_chair_to_min': {
    cs: 'Kardiacké křeslo',
    en: 'Cardiac Chair',
    track: 'cardiac_chair_TO_MIN',
    conflicting: [],
    overrides: [
      {
        animation: 'bed_height_adjustment_down',
        reverse: false
      },
      {
        animation: 'cardiac_chair',
        reverse: true
      }
    ],
  },
  'mobilization_position': {
    cs: 'Mobilizační poloha',
    en: 'Mobilization Position',
    track: 'MOBILIZATION_POSITION_MOBILIFT',
    conflicting: [
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting3',
      'combined_tilting4',
      'cardiac_chair',
      'bed_height_adjustment_up',
      'cardiac_chair_from_min',
      'vascular_position',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
      'trendelenburg',
      'reverse_trendelenburg',
      'trendelenburg_z_minima',
      'mobi_lift_handle',
      'folding_of_foot_siderails',
      'folding_of_head_siderails'
    ],
    reverseInOrder: [
      'backrest_adjustment',
      'leg_adjustment'
    ],
    conditional: [
      {
        conditionalAnimation: 'bed_height_adjustment_down',
        substituteAnimation: 'mobilization_from_min'
      }
    ],
    reversable: false
  },
  'mobilization_from_min': {
    cs: 'Mobilizační poloha',
    en: 'Mobilization Position',
    track: 'MOBILIZATION_FROM_MIN',
    conflicting: [
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting3',
      'combined_tilting4',
      'cardiac_chair',
      'bed_height_adjustment_up',
      'cardiac_chair_from_min',
      'vascular_position',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
      'trendelenburg',
      'reverse_trendelenburg',
      'trendelenburg_z_minima',
      'mobi_lift_handle',
      'folding_of_foot_siderails',
      'folding_of_head_siderails'
    ],
    reverseInOrder: [
      'backrest_adjustment',
      'leg_adjustment'
    ],
  },
  'mobilization_to_min': {
    cs: 'Mobilizační poloha',
    en: 'Mobilization Position',
    track: 'MOBILIZATION_TO_MIN',
    conflicting: [],
    overrides: [
      {
        animation: 'bed_height_adjustment_down',
        reverse: false
      },
      {
        animation: 'mobilization_position',
        reverse: true
      }
    ],
  },
  'cpr': {
    cs: 'CPR pozice',
    en: 'CPR Position',
    track: 'BED_HEIGHT_ADJUSTMENT_MIN',
    conflicting: [
      'bed_height_adjustment_up',
      'trendelenburg',
      'trendelenburg_z_minima',
      'reverse_trendelenburg',
      'emergency_trendelenburg',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'vascular_position',
      'mobilization_position',
      'mobilization_from_min',
      'frame_based_lateral_tilt_left15',
      'frame_based_lateral_tilt_right15',
      'frame_based_lateral_tilt_left30',
      'frame_based_lateral_tilt_right30',
      'combined_tilting1',
      'combined_tilting2',
      'combined_tilting3',
      'combined_tilting4',
    ],
    conditional: [
      {
        conditionalAnimation: 'mobilization_position',
        substituteAnimation: 'mobilization_to_min'
      },
      {
        conditionalAnimation: 'cardiac_chair_from_min',
        substituteAnimation: 'cardiac_chair_to_min'
      },
      {
        conditionalAnimation: 'trendelenburg',
        substituteAnimation: 'trendelenburg_z_minima_reversed'
      },
      {
        conditionalAnimation: 'reverse_trendelenburg',
        substituteAnimation: 'rev_trendelenburg_do_min'
      }
    ],
    reverseInOrder: [
      'backrest_adjustment',
      'leg_adjustment'
    ],
    reversable: false
  },
  'mobi_lift_handle': {
    cs: 'Mobi-Lift',
    en: 'Mobi-Lift',
    track: 'mobilift',
    conflicting: ['mobilization_position']
  }
}
